/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiSurfacePattern {
    StackHz = 'StackHz',
    StackVt = 'StackVt',
    HalfHz = 'HalfHz',
    HalfVt = 'HalfVt',
    ThirdHz = 'ThirdHz',
    ThirdVt = 'ThirdVt',
    RandomHz = 'RandomHz',
    RandomVt = 'RandomVt',
    OffsetHz = 'OffsetHz',
    OffsetVt = 'OffsetVt',
    FallingHz = 'FallingHz',
    RisingHz = 'RisingHz',
    MirroredHz = 'MirroredHz',
    ZigzagHz = 'ZigzagHz',
    ZigzagVt = 'ZigzagVt',
    HerringboneHz = 'HerringboneHz',
    HerringboneVt = 'HerringboneVt'
}

export function ApiSurfacePatternFromJSON(json: any): ApiSurfacePattern {
    return ApiSurfacePatternFromJSONTyped(json, false);
}

export function ApiSurfacePatternFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSurfacePattern {
    return json as ApiSurfacePattern;
}

export function ApiSurfacePatternToJSON(value?: ApiSurfacePattern | null): any {
    return value as any;
}

